// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Rj","marginNormal":"az_Sj","marginDense":"az_Tj","fullWidth":"az_Uj"};